import PropTypes from 'prop-types'
import { forwardRef, memo, useMemo } from 'react'
import SunburstBackground from 'components/elements/SunburstBackground/SunburstBackground'
import useFallbackRef from 'lib/react/hooks/useFallbackRef'
import classNames from 'lib/util/classNames'
import { useLineItemContext } from '../LineItem'
import lineItemStyles from '../LineItem.module.scss'
import styles from './Media.module.scss'

/**
 * The `Media`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
const Media = forwardRef((props, forwardedRef) => {
  const { Tag, children, className, size, ...rest } = props
  const { isIntersecting } = useLineItemContext()
  const ref = useFallbackRef(forwardedRef)
  const classNameOutput = useMemo(
    () =>
      classNames([
        className,
        lineItemStyles.media,
        styles.media,
        styles[`size-${size}`]
      ]),
    [className, size]
  )

  return (
    <Tag ref={ref} className={classNameOutput} {...rest}>
      {isIntersecting && (
        <>
          <SunburstBackground />
          {children}
        </>
      )}
    </Tag>
  )
})

// Display name
Media.displayName = 'Media'

/** @type {object} */
Media.propTypes = {
  Tag: PropTypes.elementType,
  children: PropTypes.node,
  className: PropTypes.string,
  size: PropTypes.string
}

/** @type {object} */
Media.defaultProps = {
  Tag: 'div',
  children: null,
  className: '',
  size: 'standard'
}

// Memoize
export default memo(Media)
